import type { Locale } from '@wally-reseller/shared';
import { createContext, useContext, type ReactNode } from 'react';

/**
 * The language shared components speak (their own strings are `ui.*` keys in the shared i18n
 * catalogue): the admin app passes the staff member’s language, the portal the partner user’s.
 */
const UiLocaleContext = createContext<Locale>('fr');

export function UiLocaleProvider({ locale, children }: { locale: Locale; children: ReactNode }) {
  return <UiLocaleContext.Provider value={locale}>{children}</UiLocaleContext.Provider>;
}

export function useUiLocale(): Locale {
  return useContext(UiLocaleContext);
}
